<div class="title-page">
  <h1>
    {{ title }}<small>{{ subtitle ? ' - ' + subtitle : '' }}</small>
  </h1>
</div>
